import React from 'react'
import PropTypes from 'prop-types'
import StyleContext from 'isomorphic-style-loader/StyleContext'

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */
function App({ context, children }) {
  return (
    <StyleContext.Provider value={context}>
      {children}
    </StyleContext.Provider>
  )
}

App.propTypes = {
  context: PropTypes.shape({
    insertCss: PropTypes.func.isRequired
  }).isRequired,
  children: PropTypes.element.isRequired
}

export default App
